import React from "react";
import PropTypes from "prop-types";
import { compact, get } from "sites-common/utils/lodash";
// import styles from "./bootstrap.module.css";
const styles = {};
const prefix = (c) => get(styles, [c], "");

const prefixClassname = (cname) =>
  compact(cname.split(" ")).map(prefix).join(" ");

/** Bootstrap row */
export const RowWithoutMemo = ({ className, ...props }) => (
  <div {...props} className={prefixClassname(`row ${className}`)} />
);
RowWithoutMemo.propTypes = {
  className: PropTypes.string,
};
RowWithoutMemo.defaultProps = {
  className: "",
};
export const Row = React.memo(RowWithoutMemo);

/** Bootstrap col */
export const ColumnWithoutMemo = ({ className, ...props }) => (
  <div {...props} className={prefixClassname(`${className}`)} />
);
ColumnWithoutMemo.propTypes = {
  className: PropTypes.string,
};
ColumnWithoutMemo.defaultProps = {
  className: "",
};
export const Column = React.memo(ColumnWithoutMemo);

/** Bootstrap container */
export const ContainerWithoutMemo = ({ className, ...props }) => (
  <div {...props} className={prefixClassname(`container ${className}`)} />
);
ContainerWithoutMemo.propTypes = {
  className: PropTypes.string,
};
ContainerWithoutMemo.defaultProps = {
  className: "",
};
export const Container = React.memo(ColumnWithoutMemo);

/** Bootstrap <div /> */
export const DivWithoutMemo = ({ className, ...props }) => (
  <div {...props} className={prefixClassname(`${className}`)} />
);
DivWithoutMemo.propTypes = {
  className: PropTypes.string,
};
DivWithoutMemo.defaultProps = {
  className: "",
};
export const Div = React.memo(DivWithoutMemo);

/** Bootstrap <span /> */
export const SpanWithoutMemo = ({ className, ...props }) => (
  <span {...props} className={prefixClassname(`${className}`)} />
);
SpanWithoutMemo.propTypes = {
  className: PropTypes.string,
};
SpanWithoutMemo.defaultProps = {
  className: "",
};
export const Span = React.memo(SpanWithoutMemo);

/** Bootstrap <ul /> */
export const UlWithoutMemo = ({ className, ...props }) => (
  <ul {...props} className={prefixClassname(`${className}`)} />
);
UlWithoutMemo.propTypes = {
  className: PropTypes.string,
};
UlWithoutMemo.defaultProps = {
  className: "",
};
export const Ul = React.memo(UlWithoutMemo);

/** Bootstrap <li /> */
export const LiWithoutMemo = ({ className, ...props }) => (
  <li {...props} className={prefixClassname(`${className}`)} />
);
LiWithoutMemo.propTypes = {
  className: PropTypes.string,
};
LiWithoutMemo.defaultProps = {
  className: "",
};
export const Li = React.memo(LiWithoutMemo);

/** <i /> */
export const IWithoutMemo = ({ className, ...props }) => (
  <i {...props} className={prefixClassname(`${className}`)} />
);
IWithoutMemo.propTypes = {
  className: PropTypes.string,
};
IWithoutMemo.defaultProps = {
  className: "",
};
export const I = React.memo(IWithoutMemo);

/** Bootstrap <table /> */
export const TableWithoutMemo = ({ className, ...props }) => (
  <table {...props} className={prefixClassname(`${className}`)} />
);
TableWithoutMemo.propTypes = {
  className: PropTypes.string,
};
TableWithoutMemo.defaultProps = {
  className: "",
};
export const Table = React.memo(TableWithoutMemo);

/** Bootstrap <tr /> */
export const TrWithoutMemo = ({ className, ...props }) => (
  <tr {...props} className={prefixClassname(`${className}`)} />
);
TrWithoutMemo.propTypes = {
  className: PropTypes.string,
};
TrWithoutMemo.defaultProps = {
  className: "",
};
export const Tr = React.memo(TrWithoutMemo);

/** Bootstrap <td /> */
const TdWithoutMemo = ({ className, ...props }) => (
  <td {...props} className={prefixClassname(`${className}`)} />
);
TdWithoutMemo.propTypes = {
  className: PropTypes.string,
};
TdWithoutMemo.defaultProps = {
  className: "",
};
export const Td = React.memo(TdWithoutMemo);

/** Bootstrap <th /> */
export const ThWithoutMemo = ({ className, ...props }) => (
  <th {...props} className={prefixClassname(`${className}`)} />
);
ThWithoutMemo.propTypes = {
  className: PropTypes.string,
};
ThWithoutMemo.defaultProps = {
  className: "",
};
export const Th = React.memo(ThWithoutMemo);

/** Bootstrap <th /> */
const TBodyWithoutMemo = ({ className, ...props }) => (
  <tbody {...props} className={prefixClassname(`${className}`)} />
);
TBodyWithoutMemo.propTypes = {
  className: PropTypes.string,
};
TBodyWithoutMemo.defaultProps = {
  className: "",
};
export const Tbody = React.memo(TBodyWithoutMemo);

/** Bootstrap <th /> */
export const THeadWithoutMemo = ({ className, ...props }) => (
  <thead {...props} className={prefixClassname(`${className}`)} />
);
THeadWithoutMemo.propTypes = {
  className: PropTypes.string,
};
THeadWithoutMemo.defaultProps = {
  className: "",
};
export const Thead = React.memo(THeadWithoutMemo);

/** Bootstrap <dl /> */
export const DlWithoutMemo = ({ className, ...props }) => (
  <dl {...props} className={prefixClassname(`${className}`)} />
);
DlWithoutMemo.propTypes = {
  className: PropTypes.string,
};
DlWithoutMemo.defaultProps = {
  className: "",
};
export const Dl = React.memo(DlWithoutMemo);
